export default "__VITE_ASSET__CL20m7Km__"